/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_MortgageInputs */

const cs_form_mortgage = /** @type {(inputs: Form_MortgageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Možnost hypotéky`)
};

const en_form_mortgage = /** @type {(inputs: Form_MortgageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mortgage available`)
};

/**
* | output |
* | --- |
* | "Mortgage available" |
*
* @param {Form_MortgageInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_mortgage = /** @type {((inputs?: Form_MortgageInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_MortgageInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_mortgage(inputs)
	return cs_form_mortgage(inputs)
});